import React from "react";
import { Link } from "react-router-dom";
import brokenGraphic from "components/Images/error-500.svg";

const ServerError = () => {
  return (
    <div className="error">
      <div className="error__container">
        <img
          className="error__image"
          src={brokenGraphic}
          alt="simple illustration of a broken foot"
        />
        <div className="error__text">
          <h1>Looks like something is broken.</h1>
          <p>
            Try browsing our extensive <Link to="/catalog">course catalog</Link>
            , or <Link to="/contact-us">contact us</Link>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServerError;
